import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ArrowleftIcon from 'icons/Arrowleft.icon';
import { Trans } from 'react-i18next';
import ArrowrightIcon from 'icons/Arrowright.icon';

import './BulkAploadActions.styles.scss';
import './BulkAploadActions.styles.responsive.scss';

type BulkAploadActionsProps = {
  className?: string;
  isDisabled?: boolean;
  title: string;
  numberOfProcessableColumns: number;
  numberOfUnProcessableColumns: number;
  onClear: () => void;
  handleBulkUpload: () => void;
};

const BulkAploadActions: React.FC<BulkAploadActionsProps> = (props) => {
  const {
    className,
    isDisabled,
    title,
    numberOfProcessableColumns,
    numberOfUnProcessableColumns,
    onClear,
    handleBulkUpload,
  } = props;

  const classes = classNames('bulk-apload-actions', className);

  return (
    <div className={classes}>
      <div>
        <Button
          type="button"
          variant="link"
          className="back-button"
          icon={ArrowleftIcon}
          onClick={onClear}
        />

        <p>
          <Trans
            i18nKey="columnsWillProcess"
            values={{ count: numberOfProcessableColumns }}
            components={{ b: <b /> }}
          />{' '}
          {!!numberOfUnProcessableColumns && (
            <Trans
              i18nKey="columnsWillNotProcess"
              values={{ count: numberOfUnProcessableColumns }}
              components={{ b: <b /> }}
            />
          )}
        </p>

        <Button
          className="upload"
          iconPosition="right"
          icon={ArrowrightIcon}
          onClick={handleBulkUpload}
          disabled={isDisabled}
        >
          {title}
        </Button>
      </div>
    </div>
  );
};

export default BulkAploadActions;
